import React from 'react';
import { Button } from 'reactstrap';

export const RefreshAgentsLogged = ({ handleRefresh }) => {
  return (
    <Button
      color="info"
      size="sm"
      onClick={handleRefresh}
      title="Recarrega as informações de login dos atendentes, tanto os logados em fila como os logados no sistema"
    >
      <i className="fas fa-sync-alt mr-2" />
      Atualizar
    </Button>
  );
};
